import {dataHooks} from '@wix/data-hooks'

export const notAcceptingBannerDataHooks = dataHooks<{
  root: {}
}>('not-accepting-banner')
